$(document).ready(function() {
    $(".announcement_bar__button").on("click", function (e) {
    e.preventDefault();
        $(".announcementbar__newsletter").addClass("active");
    });

    $(".announcementbar__close").on("click", function (e) {
    e.preventDefault();
        $(".announcementbar__newsletter").removeClass("active");
    e.stopPropagation();
    });
    $(".announcementbar__newsletter").on("click", function (e) {
        if (e.target === this) {
            $(this).removeClass("active");
        }
    });

    $(".descr_more_button").each(function() {
        var $btn = $(this);
        var $desc = $btn.siblings('.banner_desc');
        
        // Only hide button if content is short initially
        if ($desc[0].scrollHeight <= 150) {
            $btn.hide();
            $desc.css({
                height: 'auto',
                overflow: 'visible'
            });
        } else {
            // Content longer than 150px, setup toggle
            $btn.on("click", function (e) {
                e.preventDefault();
                $desc.toggleClass("show__content");
                $btn.toggleClass("active");
                $btn.find('.descr_more_text').text(
                    $desc.hasClass("show__content") ? "View less" : "View more"
                );
            });
        }
    });

    $(".content_more_button").each(function() {
        var $btn = $(this);
        var $desc = $btn.prev(".banner_content");

        // Check actual content height
        if ($desc[0].scrollHeight <= 150) {
            $btn.hide();
            $desc.css({
                height: 'auto',
                overflow: 'visible'
            });
        } else {
            // Add click handler only if content is long
            $btn.on("click", function (e) {
                e.preventDefault();
                $desc.toggleClass("show__content");
                $btn.toggleClass("open");
                $btn.text(
                    $desc.hasClass("show__content") ? "View less" : "View more"
                );
            });
        }
    });

    $(".tab").click(function () {
        var tab = $(this).data("tab");

        $(".tab").removeClass("active");
        $(this).addClass("active");

        $(".tab-content").removeClass("active");
        $(".tab-content[data-tab='" + tab + "']").addClass("active");
        if(tab == 'reviews'){
        $('#shopify-section-template--25215100420386__175610453934eab268').addClass('active');
        }else{
        $('#shopify-section-template--25215100420386__175610453934eab268').removeClass('active');
        }
    });

    $(".read_more_btn").on("click", function (e) {
        e.preventDefault();
        var $description = $(this).prev(".single_products_des");
        $description.toggleClass("full_content");
        $(this).toggleClass("open");
        $(this).text(
        $description.hasClass("full_content") ? "View less" : "View more"
        );
    });
});